import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import * as authService from '../../services/authService';
import '../start/PasswordGate.css';
import './LoginPage.css';

const VerifyEmailPendingPage = () => {
  const history = useHistory();
  const location = useLocation();
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState('');
  const [error, setError] = useState('');

  const email = React.useMemo(() => {
    const params = new URLSearchParams(location.search || '');
    return (params.get('email') || '').trim().toLowerCase();
  }, [location.search]);

  const handleResend = async () => {
    if (!email) {
      setError('Email address is missing. Go back to Login and try again.');
      return;
    }
    setBusy(true);
    setError('');
    setNotice('');
    try {
      const data = await authService.resendVerification({ email });
      setNotice(data.message || 'Verification email sent. Please check your inbox.');
    } catch (err) {
      setError(err.message || 'Could not resend verification email.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="xk-gate">
      <div className="xk-gate__card xk-login-card">
        <img
          src={`${process.env.PUBLIC_URL || ''}/XLog3D Logo_Red.png`}
          alt="XLog3D"
          className="xk-gate__logo"
        />

        <h2 className="xk-gate__title">Verify your email</h2>

        <div className="xk-verify-pending">
          <p className="xk-verify-pending__lead">We sent a verification link to:</p>
          {email && <p className="xk-verify-pending__email">{email}</p>}
          <p className="xk-verify-pending__text">
            Open the link in your email to activate your account. It signs you in on the device
            where you open it; if that is a different device, come back here and sign in. Check
            Spam/Junk if you do not see it.
          </p>
        </div>

        {error && <div className="xk-gate__error">{error}</div>}
        {notice && <div className="xk-login-info">{notice}</div>}

        <button
          type="button"
          className="xk-gate__submit"
          disabled={busy || !email}
          onClick={handleResend}
        >
          {busy ? 'Sending...' : 'Resend verification email'}
        </button>

        <div className="xk-login-links">
          <button
            type="button"
            className="xk-login-link"
            disabled={busy}
            onClick={() => history.push('/login')}
          >
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPendingPage;
